import { ComponentPortal } from '@angular/cdk/portal';
import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  // STATE
  private readonly currentPortalContent: WritableSignal<ComponentPortal<unknown>|null> = signal(null);
  public  readonly portalContent:        Signal<ComponentPortal<unknown>|null>         = computed((): ComponentPortal<unknown>|null => this.currentPortalContent());

  // METHODS
  public setPortal<T>(content: ComponentPortal<T>): void {
    this.currentPortalContent.set(content);
  }

  public resetPortal(): void {
    this.currentPortalContent.set(null);
  }


}
